import { useEffect, useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import {
  setArtifactTagOverrides,
  subscribeTagOverrides,
  listArtifactTagOverrides,
  type ArtifactTagOverride,
} from '@/utils/artifact-tagging';

let loadedOnce = false;

const fetchAll = async (): Promise<ArtifactTagOverride[]> => {
  const { data, error } = await supabase
    .rpc('public_artifact_tag_overrides');
  if (error) throw error;
  return (data ?? []).map((row: any) => ({
    artifactId: row.artifact_id,
    tagsAdd: row.tags_add ?? [],
    tagsRemove: row.tags_remove ?? [],
    category: row.category ?? null,
    keywords: row.keywords ?? [],
    subjects: row.subjects ?? [],
    curatorNotes: row.curator_notes ?? null,
  }));
};

export const useArtifactTagOverrides = () => {
  const [, setTick] = useState(0);
  const [loading, setLoading] = useState(!loadedOnce);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const rows = await fetchAll();
      setArtifactTagOverrides(rows);
      loadedOnce = true;
    } catch (e: any) {
      setError(e?.message ?? String(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const unsub = subscribeTagOverrides(() => setTick((n) => n + 1));
    if (!loadedOnce) void refresh();
    return () => {
      unsub();
    };
  }, [refresh]);

  return { overrides: listArtifactTagOverrides(), loading, error, refresh };
};